import { useContext } from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import i18next, { t } from "i18next";

import { formatNumber } from "src/utils/formatting";
import { isAppInPDFMode } from "src/utils/rendering";
import { RootPropsContext } from "src/components/Puck/config/root";

type GoalSectionProps = {
    score: number;
    year: number;
    unitLabel: string;
};

export const GoalSection = (props: GoalSectionProps) => {
    const { score, year, unitLabel } = props;
    const theme = useTheme();
    const rootProps = useContext(RootPropsContext);
    const isPdfMode = rootProps?.pageType === "PDF" || isAppInPDFMode();
    const footerMinHeight = theme.spacing(6);
    const ctaMinHeight = isPdfMode ? 0 : theme.spacing(5);

    return (
        <Stack spacing={theme.spacing(1)} alignItems="center" p={theme.spacing(4)} sx={{ height: "100%" }}>
            <Typography variant="h2" align="center">
                {t("puck.widgets.actionplan.goal.title")}
            </Typography>
            <Typography
                variant="body2"
                fontWeight={theme.typography.fontWeightMedium}
                fontSize={theme.typography.h3.fontSize}
                align="center"
            >
                {year}
            </Typography>
            <Box
                sx={{
                    flexGrow: 1,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        width: "100%",
                        maxWidth: "300px",
                        aspectRatio: "1 / 1",
                        borderRadius: "100%",
                        backgroundColor: `${theme.palette.primary.main}25`,
                    }}
                >
                    <Typography variant="h1" align="center">
                        {formatNumber(score, i18next.language)}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        align="center"
                        sx={{ color: theme.custom.grey[1900] }}
                    >
                        {unitLabel}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ minHeight: footerMinHeight, width: "100%" }} />
            <Box sx={{ minHeight: ctaMinHeight, width: "100%" }} />
        </Stack>
    );
};

export default GoalSection;
